import { render, staticRenderFns } from "./OrderDetailHeader.vue?vue&type=template&id=401f8c3c&scoped=true&"
import script from "./OrderDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailHeader.vue?vue&type=style&index=0&id=401f8c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401f8c3c",
  null
  
)

export default component.exports